{
 "name": "0_plant_mushroom3",
 "bin": "0_plant_mushroom3.bin",
 "nodes": [
  {"name": "", "parent": -1, "t": [0,0,0], "q": [0,0,0,1], "s": [1,1,1]},
  {"name": "Fbx_Root", "parent": 0, "t": [0,0,0], "q": [-0.7071068,0,0,0.7071068], "s": [0.0254,0.0254,0.0254]},
  {"name": "Producer Perspective", "parent": 0, "t": [0,0.713,2.875], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Top", "parent": 0, "t": [0,40,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Bottom", "parent": 0, "t": [0,-40,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Front", "parent": 0, "t": [0,0,40], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Back", "parent": 0, "t": [0,0,-40], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Right", "parent": 0, "t": [40,0,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Left", "parent": 0, "t": [-40,0,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Camera Switcher", "parent": 0, "t": [0,0,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "0_mushroom3", "parent": 1, "t": [3.831234,-24.6362,0], "q": [0,-0.7435651,0,0.6686635], "s": [1,1,1]},
  {"name": "", "parent": 10, "t": [0.4052629,24.6362,3.809738], "q": [0,0,0,1], "s": [1,1,1]},
  {"name": "0_plant_mushroom3", "parent": 10, "t": [-14.49372,14.67678,-5.288261], "q": [-0.5591829,-0.4327505,-0.4324232,0.5595102], "s": [1.2,1.2,1.2]},
  {"name": "Sphere01", "parent": 12, "t": [10.13268,9.798158,8.031847], "q": [0.07738367,0.01558748,0.003587589,0.9968731], "s": [1.32895,1.32895,0.8942552]}
 ],
 "parts": [
  {"node": 13, "vertexCount": 144, "posOffset": 0, "nrmOffset": 1728, "uvOffset": 3456, "material": "0_plant_mushroom3", "color": [1,0,0,1], "texture": "0_plant_mushroom3b.png"}
 ],
 "anims": [
  {"name": "die", "duration": 0.8, "fps": 30, "frames": 25, "offset": 4608},
  {"name": "grow", "duration": 3.3, "fps": 30, "frames": 100, "offset": 18608},
  {"name": "idle", "duration": 0.36667, "fps": 30, "frames": 12, "offset": 74608},
  {"name": "pick", "duration": 0.96667, "fps": 30, "frames": 30, "offset": 81328}
 ]
}
